<template>
  <div class="col pb-4">
    <div class="gift-card-section">
      <div class="gift-card-create-section">
        <h4 class="heading mb-4"
												data-test="giftCardHeading"
												id="giftCardHeading">Send a Gift card.</h4>
        <div class="gift-card-create-wrapper">
          <div class="gift-card-item">
            <div class="gift1">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 250"
																			data-test="giftCardSvg1">
                <title data-test="giftCardSvgTitle"
																							id="giftCardSvgTitle">giftcard</title>
                <g style="isolation:isolate">
                  <g id="744af471-f801-4016-9696-91d5b501cd1a" data-name="Layer 1">
                    <rect width="400" height="250" style="fill:#4f2fe3" />
                    <path
                      d="M370,151a222,222,0,0,1-23.13,99H0V0H311.09A222.15,222.15,0,0,1,370,151Z"
                      style="fill:#4a2adb"
                    />
                    <path
                      d="M236,165.5A137.84,137.84,0,0,1,207.24,250H0V67.14A138.5,138.5,0,0,1,236,165.5Z"
                      style="fill:#4527cc"
                    />
                    <polygon
                      points="139 185 44.5 249 0 249 0 136.39 50 106 139 185"
                      style="fill:#1b158c"
                    />
                    <rect x="69.67" y="135.92" width="69.43" height="49.28" style="fill:#4f2fe3" />
                    <rect x="103.51" y="135.92" width="7.21" height="49.28" style="fill:#ffbe32" />
                    <rect
                      x="69.67"
                      y="135.92"
                      width="69.43"
                      height="5.21"
                      style="fill:#dedede;mix-blend-mode:multiply"
                    />
                    <polygon
                      points="51.79 176.12 69.67 185.2 69.67 135.92 51.79 126.84 51.79 176.12"
                      style="fill:#4f2fe3"
                    />
                    <polygon
                      points="69.67 136.25 69.67 141.14 51.79 132.06 51.79 127.16 69.67 136.25"
                      style="fill:#dedede;mix-blend-mode:multiply"
                    />
                    <polygon
                      points="60.96 131.5 60.96 180.77 59.1 179.83 59.1 130.55 60.96 131.5"
                      style="fill:#eda328"
                    />
                    <rect x="68.66" y="116.36" width="72.6" height="21.03" style="fill:#4f2fe3" />
                    <rect x="102.26" y="116.36" width="7.16" height="21.03" style="fill:#f7d245" />
                    <polygon
                      points="49.96 127.9 68.66 137.39 68.66 116.36 49.96 106.86 49.96 127.9"
                      style="fill:#4f2fe3"
                    />
                    <polygon
                      points="60.01 111.97 60.01 133 58.16 132.06 58.16 111.03 60.01 111.97"
                      style="fill:#ffbe32"
                    />
                    <polygon
                      points="141.25 116.36 68.66 116.36 60 111.96 58.17 111.03 49.96 106.86 120.51 106.86 129.61 111.03 131.65 111.96 141.25 116.36"
                      style="fill:#4f2fe3"
                    />
                    <polygon
                      points="131.65 111.96 60 111.96 58.17 111.03 129.61 111.03 131.65 111.96"
                      style="fill:#fad843"
                    />
                    <polygon
                      points="88.67 106.86 81.51 106.86 102.25 116.36 109.41 116.36 88.67 106.86"
                      style="fill:#fad843"
                    />
                    <path
                      d="M126.55,108.88a24.18,24.18,0,0,1-3.63,3.17H97s10.24-23.87,22.39-19.78a11,11,0,0,1,1.84.83c2.5,2.27-.35,6.47,2.15,9.32S127.8,107.4,126.55,108.88Z"
                      style="fill:#f7d245"
                    />
                    <path
                      d="M109.81,103.85c-4.44,4.72-8.71,7.92-9.55,7.14s2.09-5.25,6.54-10,8.71-7.92,9.55-7.14S114.26,99.12,109.81,103.85Z"
                      style="fill:#eda328"
                    />
                    <path
                      d="M97.52,112.05H71.6A24.57,24.57,0,0,1,68,108.88c-1.24-1.48.68-3.63,3.18-6.46,2.14-2.44.36-5.88,1.39-8.24a3,3,0,0,1,.76-1.08C86.23,85.73,97.52,112.05,97.52,112.05Z"
                      style="fill:#f7d245"
                    />
                    <path
                      d="M84.7,103.85c4.44,4.72,8.72,7.92,9.55,7.14s-2.09-5.25-6.53-10S79,93.09,78.17,93.87,80.26,99.12,84.7,103.85Z"
                      style="fill:#eda328"
                    />
                    <path
                      d="M104.24,108.94v1.24a1.87,1.87,0,0,1-1.87,1.87H92.15a1.88,1.88,0,0,1-1.88-1.87v-1.24a1.42,1.42,0,0,1,0-.36v0a1.88,1.88,0,0,1,1.84-1.49h10.22a1.88,1.88,0,0,1,1.83,1.49v0A1.42,1.42,0,0,1,104.24,108.94Z"
                      style="fill:#eda328"
                    />
                    <path
                      d="M104.2,108.56v0a1.89,1.89,0,0,1-1.83,1.49H92.15a1.89,1.89,0,0,1-1.84-1.49v0a1.88,1.88,0,0,1,1.84-1.49h10.22A1.88,1.88,0,0,1,104.2,108.56Z"
                      style="fill:#f7d245"
                    />
                    <path
                      d="M126.55,108.88a24.18,24.18,0,0,1-3.63,3.17H105.83a6.94,6.94,0,0,1,1.53-1.24c2-1.18,4.43-1.48,6.71-2,2.57-.64,5.36-2,6-4.55a8.52,8.52,0,0,0,.08-2.85c-.27-3-.52-6.07-.79-9.1a11,11,0,0,1,1.84.83c2.5,2.27-.35,6.47,2.15,9.32S127.8,107.4,126.55,108.88Z"
                      style="fill:#ffbe32"
                    />
                    <path
                      d="M91.58,112.05h-20A24.57,24.57,0,0,1,68,108.88c-1.24-1.48.68-3.63,3.18-6.46,2.14-2.44.36-5.88,1.39-8.24.37,1.42.74,2.85,1.12,4.27a25.25,25.25,0,0,0,1.73,5.16,13.5,13.5,0,0,0,11.85,7.32,10.71,10.71,0,0,1,2.89.16A2.77,2.77,0,0,1,91.58,112.05Z"
                      style="fill:#ffbe32"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="gift2 d-none">
              <svg
                enable-background="new 0 0 400 250"
                version="1.1"
                viewBox="0 0 400 250"
                xml:space="preserve"
                xmlns="http://www.w3.org/2000/svg"
																data-test="giftCardSvg2"
              >
                <rect width="400" height="250" fill="#32E078" />
                <path
                  d="M370,151c0,35.6-8.3,69.2-23.1,99H0V0h311.1C347.7,39.7,370,92.8,370,151z"
                  fill="#2BD670"
                />
                <path
                  d="M236,165.5c0,31.8-10.7,61.1-28.8,84.5H0V67.1C25,42.3,59.5,27,97.5,27C174,27,236,89,236,165.5z"
                  fill="#2FCC72"
                />
                <polygon points="38 117 0 162 0 250 70.2 250 158 152" fill="#178744" />
                <polygon points="157.7 130.3 157.7 151.5 99.4 175 99.4 153.8" fill="#27B761" />
                <polygon
                  points="157.7 130.3 157.7 133.2 147.7 155.5 143.5 157.2 155.2 131.3"
                  fill="#8E6CFE"
                />
                <polygon points="147.9 134.3 136.2 160.1 132.1 161.8 143.8 135.9" fill="#8E6CFE" />
                <polygon points="136.5 138.9 124.8 164.8 120.6 166.4 132.3 140.5" fill="#8E6CFE" />
                <polygon points="125 143.5 113.3 169.4 109.2 171 120.9 145.2" fill="#8E6CFE" />
                <polygon
                  points="113.6 148.1 101.9 174 99.4 175 99.4 172 109.4 149.8"
                  fill="#8E6CFE"
                />
                <g fill="#fff">
                  <path
                    d="m150.6 136.6c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8c0.7-0.2 1.3 0.1 1.3 0.8z"
                  />
                  <path
                    d="m147 145.7c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8 1.3 0.1 1.3 0.8z"
                  />
                  <path
                    d="m143.3 154.8c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8 1.3 0.1 1.3 0.8z"
                  />
                </g>
                <g fill="#fff">
                  <path d="m157.7 140.1v2.6c-0.7 0.3-1.3-0.1-1.3-0.8s0.6-1.6 1.3-1.8z" />
                  <path
                    d="m155.4 149.9c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8 1.3 0.1 1.3 0.8z"
                  />
                </g>
                <g fill="#fff">
                  <path
                    d="m139.1 141.3c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8 1.3 0.1 1.3 0.8z"
                  />
                  <path
                    d="m135.5 150.3c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8c0.7-0.2 1.3 0.1 1.3 0.8z"
                  />
                  <path
                    d="m131.8 159.4c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8 1.3 0.1 1.3 0.8z"
                  />
                </g>
                <g fill="#fff">
                  <path
                    d="m127.6 145.9c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8 1.3 0.1 1.3 0.8z"
                  />
                  <path
                    d="m123.9 155c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8c0.8-0.3 1.3 0.1 1.3 0.8z"
                  />
                  <path
                    d="m120.3 164c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8c0.7-0.2 1.3 0.1 1.3 0.8z"
                  />
                </g>
                <g fill="#fff">
                  <path
                    d="m116.1 150.5c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8c0.7-0.2 1.3 0.1 1.3 0.8z"
                  />
                  <path
                    d="m112.4 159.6c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8 1.3 0.1 1.3 0.8z"
                  />
                  <path
                    d="m108.8 168.7c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8 1.3 0.1 1.3 0.8z"
                  />
                </g>
                <g fill="#fff">
                  <path
                    d="m104.6 155.2c0 0.7-0.6 1.5-1.3 1.8s-1.3-0.1-1.3-0.8 0.6-1.5 1.3-1.8 1.3 0.1 1.3 0.8z"
                  />
                  <path
                    d="m100.9 164.2c0 0.7-0.6 1.5-1.3 1.8-0.1 0-0.2 0.1-0.3 0.1v-2.6c0.1-0.1 0.2-0.1 0.3-0.1 0.7-0.2 1.3 0.1 1.3 0.8z"
                  />
                </g>
                <polygon points="157.8 130.3 157.8 134.6 99.4 158.1 99.4 153.8" opacity=".14" />
                <polygon
                  points="160.5 117.2 160.5 129.2 134.1 139.8 134.1 139.8 127.7 142.4 99.4 153.8 99.4 140.2 127.7 129.6 134.1 127.2"
                  fill="#2AC669"
                />
                <polygon points="134.1 127.2 134.1 139.8 127.7 142.4 127.7 129.6" fill="#FF7F70" />
                <polygon points="127.7 142.4 127.7 163.6 134.1 161 134.1 139.8" fill="#FB5441" />
                <polygon points="41 130.3 41 151.5 99.4 175 99.4 153.8" fill="#279654" />
                <polygon points="41 130.3 41 133.2 51 155.5 55.2 157.2 43.5 131.3" fill="#705EE4" />
                <polygon points="50.8 134.3 62.5 160.1 66.6 161.8 54.9 135.9" fill="#705EE4" />
                <polygon points="62.2 138.9 73.9 164.8 78.1 166.4 66.4 140.5" fill="#705EE4" />
                <polygon points="73.7 143.5 85.4 169.4 89.5 171 77.8 145.2" fill="#705EE4" />
                <polygon points="85.1 148.1 96.8 174 99.4 175 99.4 172 89.3 149.8" fill="#705EE4" />
                <g fill="#fff">
                  <path
                    d="m48.1 136.6c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8-1.3 0.1-1.3 0.8z"
                  />
                  <path
                    d="m51.7 145.7c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8-1.3 0.1-1.3 0.8z"
                  />
                  <path
                    d="m55.4 154.8c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8-1.3 0.1-1.3 0.8z"
                  />
                </g>
                <g fill="#fff">
                  <path d="m41 140.1v2.6c0.7 0.3 1.3-0.1 1.3-0.8s-0.6-1.6-1.3-1.8z" />
                  <path
                    d="m43.3 149.9c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8-1.3 0.1-1.3 0.8z"
                  />
                </g>
                <g fill="#fff">
                  <path
                    d="m59.6 141.3c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8-1.3 0.1-1.3 0.8z"
                  />
                  <path
                    d="m63.2 150.3c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8c-0.7-0.2-1.3 0.1-1.3 0.8z"
                  />
                  <path
                    d="m66.9 159.4c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8-1.3 0.1-1.3 0.8z"
                  />
                </g>
                <g fill="#fff">
                  <path
                    d="m71.1 145.9c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8-1.3 0.1-1.3 0.8z"
                  />
                  <path
                    d="m74.8 155c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8c-0.8-0.3-1.3 0.1-1.3 0.8z"
                  />
                  <path
                    d="m78.4 164c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8c-0.7-0.2-1.3 0.1-1.3 0.8z"
                  />
                </g>
                <g fill="#fff">
                  <path
                    d="m82.6 150.5c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8c-0.7-0.2-1.3 0.1-1.3 0.8z"
                  />
                  <path
                    d="m86.3 159.6c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8-1.3 0.1-1.3 0.8z"
                  />
                  <path
                    d="m89.9 168.7c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8-1.3 0.1-1.3 0.8z"
                  />
                </g>
                <g fill="#fff">
                  <path
                    d="m94.1 155.2c0 0.7 0.6 1.5 1.3 1.8s1.3-0.1 1.3-0.8-0.6-1.5-1.3-1.8-1.3 0.1-1.3 0.8z"
                  />
                  <path
                    d="m97.8 164.2c0 0.7 0.6 1.5 1.3 1.8 0.1 0 0.2 0.1 0.3 0.1v-2.6c-0.1-0.1-0.2-0.1-0.3-0.1-0.7-0.2-1.3 0.1-1.3 0.8z"
                  />
                </g>
                <polygon points="99.4 153.8 99.4 157.9 40.9 134.4 40.9 130.3" opacity=".14" />
                <polygon
                  points="99.4 140.2 99.4 153.8 71 142.4 64.6 139.8 64.6 139.8 38.2 129.2 38.2 117.2 64.6 127.2 71 129.6"
                  fill="#27B761"
                />
                <polygon points="71 129.6 71 142.4 64.6 139.8 64.6 127.2" fill="#FB5441" />
                <polygon points="71 142.4 71 163.6 64.6 161 64.6 139.8" fill="#B82827" />
                <polygon
                  points="160.5 117.2 134.1 127.2 127.7 129.6 99.4 140.2 71 129.6 64.6 127.2 38.2 117.2 72 110.3 80.3 108.6 99.4 104.8 116.6 108.3 126.5 110.3"
                  fill="#30E579"
                />
                <polygon
                  points="134.1 127.2 127.7 129.6 99.3 119.7 92 117.2 72 110.3 80.3 108.6 98.5 114.9 98.5 114.9 105.9 117.4"
                  fill="#FF7F70"
                />
                <polygon
                  points="126.5 110.3 105.9 117.4 99.3 119.7 71 129.6 64.6 127.2 92 117.2 98.5 114.9 116.6 108.3"
                  fill="#FF7F70"
                />
                <path
                  d="m99 118.2s1.9-17.9 10.6-15.7c8.7 2.3 0 11.2 0 11.2s1.5-7-1.5-7.3-7.6 6.1-9.1 11.8z"
                  fill="#B82827"
                />
                <path
                  d="m116.3 119.8-5.2 3.7s-7.8-1.5-12.1-5.2l4.8-2.2c0-0.1 6.5 3.4 12.5 3.7z"
                  fill="#B82827"
                />
                <path
                  d="m99 118.2s19-12.3 22.5-5.9c3.5 6.3 0.6 8.6-1.4 9.3s-9 1.8-9 1.8 3.3-7-0.4-8.7c-0.8-0.4-1.8-0.3-2.6 0l-9.1 3.5z"
                  fill="#FB5441"
                />
                <path
                  d="m81.7 119.8 5.2 3.7s7.8-1.5 12.1-5.2l-4.8-2.2c0-0.1-6.4 3.4-12.5 3.7z"
                  fill="#FB5441"
                />
                <path
                  d="m99 118.2s-1.9-17.9-10.6-15.7 0 11.2 0 11.2-1.5-7 1.5-7.3c3.1-0.3 7.6 6.1 9.1 11.8z"
                  fill="#FB5441"
                />
                <path
                  d="m99 118.2s-19-12.3-22.5-5.9c-3.5 6.3-0.6 8.6 1.4 9.3s9 1.8 9 1.8-3.3-7 0.4-8.7c0.8-0.4 1.8-0.3 2.6 0l9.1 3.5z"
                  fill="#B82827"
                />
              </svg>
            </div>
            <div class="gift3 d-none">
              <svg
                enable-background="new 0 0 400 250"
                version="1.1"
                viewBox="0 0 400 250"
                xml:space="preserve"
                xmlns="http://www.w3.org/2000/svg"
																data-test="giftCardSvg3"
              >
                <rect width="400" height="250" fill="#FD6BA2" />
                <path
                  d="M370,151c0,35.6-8.3,69.2-23.1,99H0V0h311.1C347.7,39.7,370,92.8,370,151z"
                  fill="#FC5B9C"
                />
                <path
                  d="M236,165.5c0,31.8-10.7,61.1-28.8,84.5H0V67.1C25,42.3,59.5,27,97.5,27C174,27,236,89,236,165.5z"
                  fill="#FC4F95"
                />
                <polygon points="52.6 115.8 0.1 170.3 0.4 250.3 85 250 153 161" fill="#B51A61" />
                <polygon points="153.7 118.1 153.7 160.7 111.7 175 111.7 132.3" fill="#F92385" />
                <g fill="#FFEB93">
                  <polygon
                    points="115.8 139.4 112.5 141.9 111.7 146 111.7 133.8 111.7 133.6 112.6 138.7"
                  />
                  <polygon
                    points="126.7 133.9 129.9 134.6 126.6 137.2 125.5 142.8 124.6 137.7 121.4 136.9 124.7 134.4 125.8 128.8"
                  />
                  <polygon
                    points="140.8 129.1 144 129.8 140.7 132.4 139.5 138 138.7 132.9 135.5 132.2 138.8 129.6 139.9 124"
                  />
                  <polygon
                    points="153.7 120.7 153.7 133 153.6 133.2 152.8 128.1 149.6 127.4 152.8 124.8"
                  />
                </g>
                <g fill="#FFEB93">
                  <polygon
                    points="119.8 159.1 123 159.9 119.7 162.4 118.6 167.9 117.8 162.9 114.6 162.1 117.8 159.6 119 154.1"
                  />
                  <polygon
                    points="133.7 154.4 136.9 155.1 133.6 157.6 132.5 163.2 131.7 158.2 128.5 157.4 131.7 154.9 132.8 149.4"
                  />
                  <polygon
                    points="147.6 149.6 150.8 150.4 147.5 152.9 146.4 158.4 145.5 153.4 142.4 152.7 145.6 150.2 146.7 144.7"
                  />
                </g>
                <polygon points="134.6 167.2 130.8 168.5 130.8 125.8 134.6 124.6" fill="#705EE4" />
                <polygon points="51.4 115.2 51.4 157.8 111.7 175 111.7 132.3" fill="#d27" />
                <g fill="#FFEB93">
                  <polygon
                    points="105.8 139.1 110.5 141.9 111.7 146 111.7 133.8 111.7 133.6 110.4 138.6"
                  />
                  <polygon
                    points="90.2 132.8 85.6 133.4 90.3 136.1 91.9 141.8 93.2 136.8 97.8 136.3 93 133.5 91.4 127.8"
                  />
                  <polygon
                    points="70 127.1 65.4 127.6 70.1 130.4 71.7 136.1 72.9 131.1 77.5 130.5 72.8 127.8 71.2 122.1"
                  />
                  <polygon
                    points="51.4 117.9 51.4 130.1 51.5 130.3 52.7 125.3 57.3 124.8 52.6 122"
                  />
                </g>
                <g fill="#FFEB93">
                  <polygon
                    points="100.1 158.5 95.5 159.1 100.2 161.8 101.8 167.4 103 162.5 107.5 161.9 102.9 159.2 101.3 153.6"
                  />
                  <polygon
                    points="80.1 152.9 75.6 153.4 80.2 156.1 81.8 161.7 83 156.8 87.6 156.3 82.9 153.5 81.3 147.9"
                  />
                  <polygon
                    points="60.1 147.2 55.6 147.7 60.2 150.4 61.8 156.1 63.1 151.1 67.6 150.6 63 147.9 61.4 142.3"
                  />
                </g>
                <polygon points="78.8 165.7 84.3 167.2 84.3 124.5 78.8 123" fill="#705EE4" />
                <polygon
                  points="153.7 118.1 134.6 124.6 130.8 125.8 111.7 132.3 84.3 124.5 78.8 123 51.4 115.2 77.9 109.2 82.3 108.2 95.5 105.2 116.1 109.7 121.6 110.9"
                  fill="#F73C91"
                />
                <polygon points="134.6 124.6 130.8 125.8 77.9 109.2 82.3 108.2" fill="#B499FF" />
                <polygon points="121.6 110.9 84.3 124.5 78.8 123 116.1 109.7" fill="#B499FF" />
                <path
                  d="m103.5 116.6s2.1-19.3 11.5-16.9 0 12 0 12 1.7-7.5-1.7-7.8c-3.3-0.3-8.2 6.5-9.8 12.7z"
                  fill="#705EE4"
                />
                <path
                  d="m122.1 118.3-5.6 4s-8.4-1.7-13-5.6l5.2-2.4c-0.1-0.1 6.9 3.7 13.4 4z"
                  fill="#705EE4"
                />
                <path
                  d="m103.5 116.6s20.5-13.2 24.3-6.4 0.7 9.3-1.5 10c-2.2 0.8-9.7 2-9.7 2s3.5-7.6-0.4-9.4c-0.9-0.4-1.9-0.4-2.8 0l-9.9 3.8z"
                  fill="#B499FF"
                />
                <path
                  d="m84.8 118.3 5.6 4s8.4-1.7 13-5.6l-5.2-2.4c0.1-0.1-6.9 3.7-13.4 4z"
                  fill="#B499FF"
                />
                <path
                  d="m103.5 116.6s-2.1-19.3-11.5-16.9 0 12 0 12-1.7-7.5 1.7-7.8c3.3-0.3 8.1 6.5 9.8 12.7z"
                  fill="#B499FF"
                />
                <path
                  d="m103.5 116.6s-20.5-13.2-24.3-6.4-0.7 9.3 1.5 10c2.2 0.8 9.7 2 9.7 2s-3.5-7.6 0.4-9.4c0.9-0.4 1.9-0.4 2.8 0l9.9 3.8z"
                  fill="#705EE4"
                />
              </svg>
            </div>
            <div class="gift4 d-none">
              <svg
                enable-background="new 0 0 400 250"
                version="1.1"
                viewBox="0 0 400 250"
                xml:space="preserve"
                xmlns="http://www.w3.org/2000/svg"
																data-test="giftCardSvg4"
              >
                <rect width="400" height="250" fill="#FD6BA2" />
                <path
                  d="M370,151c0,35.6-8.3,69.2-23.1,99H0V0h311.1C347.7,39.7,370,92.8,370,151z"
                  fill="#FC5B9C"
                />
                <path
                  d="M236,165.5c0,31.8-10.7,61.1-28.8,84.5H0V67.1C25,42.3,59.5,27,97.5,27C174,27,236,89,236,165.5z"
                  fill="#FC4F95"
                />
                <polygon points="54 114 0.1 170.3 0.4 250.3 85 250 128 192" fill="#B51A61" />
                <polygon points="128.1 191.6 84.8 207 84.8 134.3 128.1 119" fill="#ED2A79" />
                <polygon points="110.4 197.9 102.4 200.7 102.4 128.1 110.4 125.2" fill="#FDD14C" />
                <polygon points="128.1 119 128.1 124.6 84.8 140 84.8 134.3" opacity=".14" />
                <polygon points="135.4 116.4 84.8 134.3 84.8 115.5 135.4 97.6" fill="#FF6EA9" />
                <polygon points="114.8 123.7 105.4 127 105.4 108.2 114.8 104.9" fill="#FDD14C" />
                <g fill="#842DBC">
                  <ellipse
                    transform="matrix(.6424 -.7664 .7664 .6424 -96.212 158.91)"
                    cx="122.2"
                    cy="182.6"
                    rx="4.2"
                    ry="3"
                  />
                  <path
                    d="m123.6 148.9c0 2.3-1.9 4.9-4.2 5.7s-4.2-0.4-4.2-2.7 1.9-4.9 4.2-5.7 4.2 0.4 4.2 2.7z"
                  />
                  <path
                    d="m96.3 150.1c0 1.7-1.4 3.6-3.1 4.2s-3.1-0.3-3.1-2 1.4-3.6 3.1-4.2 3.1 0.3 3.1 2z"
                  />
                  <path
                    d="m122.1 128.1c0 1.3-1.1 2.7-2.4 3.2s-2.4-0.2-2.4-1.5 1.1-2.7 2.4-3.2c1.4-0.4 2.4 0.2 2.4 1.5z"
                  />
                  <ellipse
                    transform="matrix(.6424 -.7664 .7664 .6424 -72.383 121.95)"
                    cx="94.5"
                    cy="138.5"
                    rx="3.5"
                    ry="2.5"
                  />
                  <path
                    d="m98.6 191.7c0 2.4-1.9 4.9-4.3 5.8-2.4 0.8-4.3-0.4-4.3-2.8s1.9-4.9 4.3-5.8c2.4-0.8 4.3 0.4 4.3 2.8z"
                  />
                  <path
                    d="m98.6 168.5c0 1.5-1.2 3.2-2.7 3.7s-2.7-0.3-2.7-1.8 1.2-3.2 2.7-3.7 2.7 0.3 2.7 1.8z"
                  />
                  <path
                    d="m117.4 168.3c0 0.6-0.5 1.3-1.1 1.5s-1.1-0.1-1.1-0.7 0.5-1.3 1.1-1.5 1.1 0.1 1.1 0.7z"
                  />
                  <path
                    d="m96.5 178.5c0 0.9-0.7 1.9-1.7 2.2-0.9 0.3-1.7-0.2-1.7-1.1s0.7-1.9 1.7-2.2 1.7 0.2 1.7 1.1z"
                  />
                  <path
                    d="m98.7 157.1c0 0.4-0.3 0.7-0.6 0.9-0.4 0.1-0.6-0.1-0.6-0.4s0.3-0.7 0.6-0.9c0.3-0.1 0.6 0 0.6 0.4z"
                  />
                  <path
                    d="m102.2 142c0 1-0.8 2-1.8 2.4-1 0.3-1.8-0.2-1.8-1.1 0-1 0.8-2 1.8-2.4 1.1-0.4 1.8 0.1 1.8 1.1z"
                  />
                  <path
                    d="m120.4 139.3c0 0.5-0.4 1-0.9 1.2s-0.9-0.1-0.9-0.6 0.4-1 0.9-1.2c0.5-0.1 0.9 0.2 0.9 0.6z"
                  />
                  <path
                    d="m115.7 186.6c0 1-0.8 2-1.8 2.4-1 0.3-1.8-0.2-1.8-1.1 0-1 0.8-2 1.8-2.4s1.8 0.1 1.8 1.1z"
                  />
                  <path
                    d="m100.5 198.8c0 0.7-0.5 1.4-1.2 1.6s-1.2-0.1-1.2-0.8 0.5-1.4 1.2-1.6c0.6-0.2 1.2 0.1 1.2 0.8z"
                  />
                </g>
                <polygon points="56.6 191.6 84.8 207 84.8 134.3 56.6 119" fill="#C9276A" />
                <polygon points="68.1 197.9 73.3 200.7 73.3 128.1 68.1 125.2" fill="#EDA328" />
                <polygon points="84.8 134.3 84.8 140.1 56.6 124.7 56.6 119" opacity=".14" />
                <polygon points="51.8 116.4 84.8 134.3 84.8 115.5 51.8 97.6" fill="#ED2A79" />
                <polygon points="65.3 123.7 71.4 127 71.4 108.2 65.3 104.9" fill="#EDA328" />
                <g fill="#622B86">
                  <path
                    d="m58.1 181.3c0 1.9 1 4.1 2.3 4.8s2.3-0.3 2.3-2.3c0-1.9-1-4.1-2.3-4.8-1.2-0.7-2.3 0.4-2.3 2.3z"
                  />
                  <path
                    d="m59.5 148.9c0 2.3 1.2 4.9 2.8 5.7 1.5 0.8 2.8-0.4 2.8-2.7s-1.2-4.9-2.8-5.7-2.8 0.4-2.8 2.7z"
                  />
                  <path d="m77.3 150.1c0 1.7 0.9 3.6 2 4.2s2-0.3 2-2-0.9-3.6-2-4.2-2 0.3-2 2z" />
                  <path
                    d="m60.5 128.1c0 1.3 0.7 2.7 1.5 3.2s1.5-0.2 1.5-1.5-0.7-2.7-1.5-3.2c-0.9-0.4-1.5 0.2-1.5 1.5z"
                  />
                  <ellipse
                    transform="matrix(.9579 -.2869 .2869 .9579 -36.454 28.34)"
                    cx="78.5"
                    cy="138.5"
                    rx="1.8"
                    ry="3.2"
                  />
                  <path
                    d="m75.8 191.7c0 2.4 1.2 4.9 2.8 5.8 1.5 0.8 2.8-0.4 2.8-2.8s-1.2-4.9-2.8-5.8c-1.6-0.8-2.8 0.4-2.8 2.8z"
                  />
                  <path
                    d="m75.8 168.5c0 1.5 0.8 3.2 1.8 3.7s1.8-0.3 1.8-1.8-0.8-3.2-1.8-3.7-1.8 0.3-1.8 1.8z"
                  />
                  <path
                    d="m63.5 168.3c0 0.6 0.3 1.3 0.7 1.5s0.7-0.1 0.7-0.7-0.3-1.3-0.7-1.5-0.7 0.1-0.7 0.7z"
                  />
                  <path
                    d="m77.1 178.5c0 0.9 0.5 1.9 1.1 2.2s1.1-0.2 1.1-1.1-0.5-1.9-1.1-2.2-1.1 0.2-1.1 1.1z"
                  />
                  <path
                    d="m75.7 157.1c0 0.4 0.2 0.7 0.4 0.9 0.2 0.1 0.4-0.1 0.4-0.4s-0.2-0.7-0.4-0.9c-0.2-0.1-0.4 0-0.4 0.4z"
                  />
                  <path
                    d="m73.4 142c0 1 0.5 2 1.1 2.4s1.1-0.2 1.1-1.1c0-1-0.5-2-1.1-2.4s-1.1 0.1-1.1 1.1z"
                  />
                  <path
                    d="m61.6 139.3c0 0.5 0.3 1 0.6 1.2s0.6-0.1 0.6-0.6-0.3-1-0.6-1.2c-0.4-0.1-0.6 0.2-0.6 0.6z"
                  />
                  <path
                    d="m64.6 186.6c0 1 0.5 2 1.1 2.4 0.6 0.3 1.1-0.2 1.1-1.1 0-1-0.5-2-1.1-2.4s-1.1 0.1-1.1 1.1z"
                  />
                  <path
                    d="m74.6 198.8c0 0.7 0.4 1.4 0.8 1.6s0.8-0.1 0.8-0.8-0.4-1.4-0.8-1.6c-0.5-0.2-0.8 0.1-0.8 0.8z"
                  />
                </g>
                <polygon
                  points="135.4 97.6 114.8 104.9 105.4 108.2 84.8 115.5 71.4 108.2 65.3 104.9 51.8 97.6 73.4 90.9 73.4 90.9 81.8 88.4 94.1 84.6 107 88.7 115.7 91.4"
                  fill="#FF96C1"
                />
                <polygon
                  points="114.8 104.9 105.4 108.2 91.4 100.6 85 97.2 73.4 90.9 81.8 88.4 93.1 94.1 93.1 94.1 99.8 97.4"
                  fill="#FDDD7C"
                />
                <polygon
                  points="115.7 91.4 99.8 97.4 91.4 100.6 71.4 108.2 65.3 104.9 85 97.2 93.1 94.1 107 88.7"
                  fill="#FDDD7C"
                />
                <path
                  d="m90.5 98.6s2.1-19.3 11.5-16.9 0 12 0 12 1.7-7.5-1.7-7.8c-3.3-0.3-8.2 6.5-9.8 12.7z"
                  fill="#EDA328"
                />
                <path
                  d="m109.1 100.2-5.6 4s-8.4-1.7-13-5.6l5.2-2.4s6.9 3.7 13.4 4z"
                  fill="#EDA328"
                />
                <path
                  d="m90.5 98.6s20.5-13.2 24.3-6.4 0.7 9.3-1.5 10c-2.2 0.8-9.7 2-9.7 2s3.5-7.6-0.4-9.4c-0.9-0.4-1.9-0.4-2.8 0l-9.9 3.8z"
                  fill="#FFBE32"
                />
                <path
                  d="m71.8 100.2 5.6 4s8.4-1.7 13-5.6l-5.2-2.4c0.1 0-6.9 3.7-13.4 4z"
                  fill="#FFBE32"
                />
                <path
                  d="m90.5 98.6s-2.1-19.3-11.5-16.9 0 12 0 12-1.7-7.5 1.7-7.8c3.3-0.3 8.1 6.5 9.8 12.7z"
                  fill="#FFBE32"
                />
                <path
                  d="m90.5 98.6s-20.5-13.2-24.3-6.4-0.7 9.3 1.5 10c2.2 0.8 9.7 2 9.7 2s-3.5-7.6 0.4-9.4c0.9-0.4 1.9-0.4 2.8 0l9.9 3.8z"
                  fill="#EDA328"
                />
              </svg>
            </div>
            <div class="gift-card-item-overlay" v-if="price"
																	data-test="giftCardPrice"
																	id="giftCardPrice">{{price|currencyConversion}}</div>
          </div>
         <gift-card-form @bindPrice="bindPrice($event)"
                         @giftCardData="giftCardBindData($event)"
                         v-if="!show"
         >
         </gift-card-form>
          <razor-pay-web-integration v-if="show">
          </razor-pay-web-integration>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { store } from '@/store/store'
import RazorPayWebIntegration from '@/components/pages/paymentGateway/razorPay/RazorPayWebIntegration'
import GiftCardForm from './Forms/GiftCardForm'
import { orderApi } from '../../../../services/ApiServices/orderApi'

export default {
	components: {
		RazorPayWebIntegration,
		GiftCardForm },
	name: 'gift-card',
	data () {
		return {
			price: '',
			giftCardData: {
				country_code: '',
				card_details: []
			},
			razorPayOrderNumber: '',
			totalAmount: '',
			show: false
		}
	},
	computed: {
		...mapGetters('siteData', ['getSelectedCountry', 'setPaymentGatewayIdData']),
		...mapGetters('user', ['getUserData', 'getOrderData']),
		...mapGetters('siteData', ['getPaymentId'])
	},
	methods: {
		bindPrice (price) {
			this.price = price
		},
		giftCardBindData (giftData) {
			this.giftCardData.country_code = this.getSelectedCountry.country_code
			this.giftCardData.card_details.push(giftData)
			orderApi.createGiftCard(this.giftCardData)
				.then((res) => {
					store.dispatch('user/setGiftCardData', res.data)
					// store.dispatch('siteData/setPaymentGatewayIdData', 'razorpay');
					this.razorPayOrderNumber = res.data.order_number
					this.totalAmount = res.data.total_amount
					this.show = true
					this.$forceUpdate()
				})
		}
	}
}
</script>

<style scoped>
</style>
